"use client";

import { useTenant } from "@tillix/tenants/react";
import {
  BaseFormRootError,
  type BaseFormRootErrorProps,
} from "./form-root-error";
import ConEdisonFormRootError from "./form-root-error.con-edison";

export function FormRootError(props: BaseFormRootErrorProps) {
  const contextTenant = useTenant();

  if (!props.rootError || props.rootError.trim() === "") return null;

  const tenantRefId = props.tenant?.id ?? contextTenant?.id;

  switch (tenantRefId) {
    case "con-edison":
      return <ConEdisonFormRootError {...props} />;

    default:
      return <BaseFormRootError {...props} />;
  }
}
